import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import { getOffset, getPrice, getSlotsByOrder, isDeliveryVenueOpen } from '../../../smoothr-web-app-core/utils/utils';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IonContent, ModalController, PickerController } from '@ionic/angular';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import * as moment from 'moment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import validator from 'validator';
import { TosPage } from '../../pages/tos/tos.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import { ValidationUtils } from '../../../smoothr-web-app-core/utils/validation-utils';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { Router } from '@angular/router';
import { calculateGeoDistance, MapsUtils } from '../../../smoothr-web-app-core/utils/maps-utils';
import { sleep, isVenueOpen, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { TimeUtils } from '../../../smoothr-web-app-core/utils/time-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { environment } from 'src/environments/environment';
import { PhoneNumber, PhoneNumberUtil } from 'google-libphonenumber';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { AvailableDriverModalComponent } from '../available-driver-modal/available-driver-modal.component';
import { countries } from '../input-phone-with-county-code/mock-countries';

@Component({
	selector: 'app-checkout-modal',
	templateUrl: './checkout-modal.component.html',
	styleUrls: ['checkout-modal.component.scss'],
})
export class CheckoutModalComponent extends RepositoryDirective implements OnInit {
	orderUtils = OrderUtils;
	loading = false;
	now: moment.Moment;
	pt = PreorderType;
	nameError: string;
	emailError: string;
	phoneError: string;
	streetNumberError: string;
	orderAtError: string;
	streetError: string;
	postalCodeError: string;
	hadPostalCode = false;
	telCountryOptions: any = {
		cssClass: 'tel-country-popover',
	};
	isVenueOpen = false;
	tip: number = 0;
	ou = OrderUtils;
	orderForm: FormGroup;
	name = 'name';
	email = 'email';
	phone = 'phone';
	note = 'note';
	orderAt = 'orderAt';

	numberToCurrency = numberToCurrency;
	slots: Moment[] = [];
	environment = environment;
	uberQoateExist: boolean = false;

	@ViewChild(IonContent, { static: false }) content;
	@ViewChild('swiperCheckout', { static: false }) slides;
	slideOptions = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false,
	};
	isOverviewPage = false;
	@Output() closedDialog = new EventEmitter<void>();
	street = 'street';
	city = 'city';
	postalCode = 'postalCode';

	number = 'number';
	totalPriceValue: string = '';
	companyDisount = '';
	totlaPriceBeforeDiscount = '';
	mappedOrderArticlesValue: ArticleGroup[] = [];
	loadQoate: boolean = false;

	constructor(
		private modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private pickerCtrl: PickerController,
		private translate: TranslateService,
		private router: Router,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder
	) {
		super(repository);
		if (this.address && this.address.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
		if (this.order && this.order.preorder && this.order.preorder.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
	}
	// ngAfterViewInit(): void {
	// 	this.toOverview(); //TODO: to remove;
	// }

	static async show(modalCtrl: ModalController, analytics: AnalyticsService, order: Order, tip: number) {
		const modal = await modalCtrl.create({
			component: CheckoutModalComponent,
			componentProps: {
				tip,
			},
			showBackdrop: true,
			backdropDismiss: true,
			cssClass: 'menu-modal',
		});
		await modal.present();
		analytics.beginCheckout(order);
		return await modal.onDidDismiss();
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.checkoutProgress(this.order, null, 1);
		this.analytics.customerBeginsCheckout();
		this.createOrderForm();

		this.checkPrevOrder();
		this.loadSlots();
		this.totalPrice();
		this.mappedOrderArticlesValue = this.order.orderedArticles.map(it => {
			it = this.mapGroup(it);
			return it;
		});
		this.orderForm.get('orderAt').valueChanges.subscribe(v => {
			if (this.venue.uberDeliveryEnabled) {
				this.uberQoateExist = false;
			}
		});
	}

	onOrder() {
		super.onOrder();
		const postalCodeInOrder =
			this.order && this.order.preorder && this.order.preorder.postalCode && this.order.preorder.postalCode.length > 0;
		this.cdr.detectChanges();
		this.totalPrice();
	}

	checkPrevOrder() {
		if (this.order && this.order.preorder) {
			if (this.repository._previousPreorder) {
				this.orderForm.patchValue({
					name: this.repository._previousPreorder?.name ?? '',
					email: this.repository._previousPreorder?.email ?? '',
				});
			}
			if (this.repository._previousPreorder?.phone) {
				let defaultPhone = {
					country: '+49',
					phone: '',
				};

				if (this.repository && this.repository._previousPreorder?.phone) {
					let countryCode = countries.find(it => this.repository._previousPreorder?.phone?.trim().startsWith('+' + it.dialCode));
					defaultPhone = {
						country: '+' + countryCode?.dialCode ?? '+49',
						phone: this.repository._previousPreorder?.phone
							? this.repository._previousPreorder?.phone?.trim()?.replace('+' + countryCode?.dialCode, '')
							: '',
					};

					this.orderForm.patchValue({
						phone: {
							country: defaultPhone.country,
							phone: defaultPhone.phone,
						},
					});
				}
			}
		}
	}

	onAddress() {
		super.onAddress();
		this.hadPostalCode = this.hadPostalCode || (this.address && this.address.postalCode && this.address.postalCode.length > 0);
	}

	onCustomer() {
		super.onCustomer();
	}

	checkCustomer() {
		console.log(this.customer);
		if (this.customer) {
			if (this.customer?.name) {
				this.orderForm.patchValue({
					name: this.customer.name,
				});
			}
			if (this.customer?.email) {
				this.orderForm.patchValue({
					email: this.customer?.email,
				});
			}
			if (this.customer?.phone) {
				let defaultPhone = {
					country: '+49',
					phone: '',
				};

				if (this.repository && this.customer?.phone && this.customer?.phone) {
					let countryCode = countries.find(it => this.customer?.phone.trim().startsWith('+' + it.dialCode));
					defaultPhone = {
						country: '+' + countryCode?.dialCode ?? '+49',
						phone: this.customer?.phone ? this.customer?.phone?.trim()?.replace('+' + countryCode?.dialCode, '') : '',
					};

					this.orderForm.patchValue({
						phone: {
							country: defaultPhone.country,
							phone: defaultPhone.phone,
						},
					});
				}
			}
		}
	}

	async close() {
		await this.updateForm();

		const data = {
			preorder: this.order.preorder,
			orderAt: this.getFormControlValue('orderAt'),
			tip: this.tip,
			asap: this.order.asap,
		};
		this.repository.previousPreorder.emit(this.order.preorder);

		await this.modalCtrl.dismiss(data);
	}

	async updateForm() {
		this.order.preorder.name = this.getFormControlValue('name');
		if (this.getFormControlValue('phone')?.phone && this.getFormControlValue('phone')?.country)
			this.order.preorder.phone = this.getFormControlValue('phone')?.country + this.getFormControlValue('phone')?.phone;
		this.order.preorder.email = this.getFormControlValue('email');
		this.order.preorder.note = this.getFormControlValue('note');
		if (this.getFormControlValue('orderAt')) {
			this.order.orderAt = this.getFormControlValue('orderAt');
		} else {
			this.order.asap = true;
		}
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			this.order.preorder.city = this.getFormControlValue('city');
			this.order.preorder.postalCode = this.getFormControlValue('postalCode');
			this.order.preorder.number = this.getFormControlValue('number');
			this.order.preorder.street = this.getFormControlValue('street');
		}
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			const company = this.repository.companyCode$.getValue();
			this.order.preorder.city = company?.deliveryAddress?.city ?? '';
			this.order.preorder.postalCode = company?.deliveryAddress?.postalCode ?? '';
			this.order.preorder.number = company?.deliveryAddress?.number ?? '';
			this.order.preorder.street = company?.deliveryAddress?.street ?? '';
		}
		this.repository.onOrderChange(this.order);
	}
	async dismiss() {
		await this.modalCtrl.dismiss();
	}

	async openTos() {
		window.open(TosPage.url, '_blank');
	}

	async openPrivacy() {
		window.open(PrivacyPage.url, '_blank');
	}

	slotToText(slot: Moment): string {
		const asapPossible = (OrderUtils.isInside(this.order) || OrderUtils.isTakeAway(this.order)) && this.isVenueOpen;
		if (!slot) {
			return this.translate.instant(asapPossible ? 'checkout_modal.first_slot' : 'checkout_modal.choose_slot');
		}
		const slotMoment = moment(slot);
		const sameDay = TimeUtils.isSameDate(slotMoment, moment());
		if (sameDay) {
			return slotMoment.format('HH:mm');
		} else {
			return slotMoment.format('DD.MM. HH:mm');
		}
	}

	onVenue() {
		this.isVenueOpen = isVenueOpen(this.venue);
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.isVenueOpen = false;
		if (this.order) {
			this.order.asap = false;
		}
	}

	async submitFormCustomValidator() {
		let controlStreetValue = this.getFormControlValue('street').trim();
		let controlHouseNumberValue = this.getFormControlValue('number').trim();
		let controlPostalCodeValue = this.getFormControlValue('postalCode').trim();
		let controlCityValue = this.getFormControlValue('city').trim();
		if (
			OrderUtils.isDelivery(this.order) &&
			(controlStreetValue !== this.address.street ||
				controlPostalCodeValue !== this.address.postalCode ||
				controlCityValue !== this.address.city ||
				controlHouseNumberValue !== this.address.number)
		) {
			try {
				const pred = controlStreetValue + ' ' + controlHouseNumberValue + ', ' + controlCityValue + ' ' + controlPostalCodeValue;
				const geocode = await MapsUtils.getPlace(pred);
				const address = MapsUtils.placeToAddress(geocode);
				const addressValidationResult = ValidationUtils.validateAddress(address, true);
				if (addressValidationResult) {
					// this.streetError = this.translate.instant(addressValidationResult);
					this.orderForm.controls['street'].setErrors({ incorrect: true });
					return false;
				}
				const delivers =
					(this.venue.deliveryByRadius &&
						calculateGeoDistance(
							address.lat,
							address.lng,
							this.venue.location.coordinates[1],
							this.venue.location.coordinates[0]
						) <= this.venue.deliveryRadius) ||
					(this.venue.isPostalDelivery && this.venue.deliveryPostalCodes.indexOf(address.postalCode));
				if (!delivers) {
					this.orderForm.controls['street'].setErrors({ street_delivery: true });

					this.snackbarCtrl.open(this.translate.instant('errors.street_delivery'), null, {
						duration: 2000,
					});
					return false;
				}
				this.repository.address.emit(address);
				this.orderForm.patchValue({
					street: this.address.street,
				});
				return true;
			} catch (e) {
				this.orderForm.controls['street'].setErrors({ street_not_found: true });
				this.snackbarCtrl.open(this.translate.instant('errors.street_not_found'), null, {
					duration: 2000,
				});
				return false;
			}
		} else {
			return true;
		}
	}
	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}
	reloadAddress() {
		if (this.order && this.order.preorder && this.address && this.order.preorder.type === PreorderType.DELIVERY && this.orderForm) {
			this.orderForm.patchValue({
				city: this.address?.city ?? '',
				street: this.address?.street ?? '',
				postalCode: this.address?.postalCode && this.address?.postalCode?.length > 0 ? this.address.postalCode : '',
				country: this.address?.country,
				number: this.address?.number,
			});
		}
	}
	async onButtonClick() {
		if (this.isFormValid)
			if (this.order?.preorder?.type === PreorderType.DELIVERY) {
				if (!(await this.submitFormCustomValidator())) {
					return;
				}
			}

		if (!this.isOverviewPage) {
			await this.toOverview();
		} else {
			await this.close();
		}
	}

	async toOverview() {
		// await this.slides.update();
		await this.slides.nativeElement.swiper.slideNext();
		console.log('Slide next');
		console.dir(this.slides.nativeElement);
		this.isOverviewPage = true;
	}
	async editPersonalData() {
		await this.slides.nativeElement.swiper.slidePrev();
		this.isOverviewPage = false;
	}
	slotSelected($event) {
		this.order.orderAt = $event;
		if (!$event) {
			this.order.asap = true;
		} else {
			this.order.asap = false;
		}
	}
	async backOrDismiss() {
		if (this.isOverviewPage) {
			await this.editPersonalData();
		} else {
			await this.dismiss();
		}
	}
	async loadSlots() {
		this.slots = [];
		this.order.orderAt = null;
		if (!this.venue) {
			this.snackbarCtrl.open(this.translate.instant('errors.venue'), null, {
				duration: 2000,
			});
			return;
		}
		// if (this.loading) {
		// 	return;
		// }
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			this.slots = [];
			this.order.orderAt = null;
			this.order.asap = true;
			return;
		}
		this.loading = true;

		try {
			//TODO: not touch while TUR testing

			const allSlots = await getSlotsByOrder(this.venue, this.order);
			const slots = [...new Set(allSlots.map(item => moment(item.time).format('X')))].map(it => moment.unix(Number(it)));
			const offset = getOffset(this.venue, this.order.type, this.order.preorder.type, null, null);
			if (slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}
			if (this.order.preorder.type != PreorderType.DELIVERY) {
				const resultOfStart = TimeUtils.doesHoursMatchOffsets(moment(), this.venue.openingHours, offset.first);

				let isVenueOpenVar = true;
				try {
					isVenueOpenVar = isVenueOpen(this.venue);
				} catch (e) {}
				if (slots.length > 0) {
					if (isVenueOpenVar && resultOfStart) {
						this.slots = [null, ...slots];
					} else {
						this.slots = [...slots];
					}
				}
			} else {
				const resultOfStart = TimeUtils.doesHoursMatchOffsets(moment(), this.venue.deliveryHours, offset.first);

				let isVenueDeliveryOpenVar = true;
				try {
					isVenueDeliveryOpenVar = isDeliveryVenueOpen(this.venue);
				} catch (e) {}
				if (slots.length > 0) {
					if (isVenueDeliveryOpenVar && resultOfStart) {
						this.slots = [null, ...slots];
					} else {
						this.slots = [...slots];
					}
				}
			}

			if (this.order.preorder.type == PreorderType.DELIVERY && this.venue?.uberDeliveryEnabled) {
				this.slots = this.slots.filter(it => !!it);
				const cutedFirstSlots = this.slots.slice(0, 3);
				const checkAvaibility = await Promise.all(
					cutedFirstSlots.map((it, index) => {
						return this.checkSlotQuate(it, true);
					})
				);
				this.slots = this.slots.filter(it => {
					const findTime = checkAvaibility.find(result => result.value.isSame(it));
					if (findTime) {
						return findTime.result;
					} else {
						return true;
					}
				});
			}

			if (this.slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000,
				});
				return;
			}
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('checkout_modal.time_error'), null, {
				duration: 2000,
			});
			console.error(e);
		}
		this.loading = false;
	}
	priceOfOption(articleGroup: ArticleGroup, articleOption: ArticleOption): number {
		const price = getPrice(articleOption.article, OrderType.PREORDER, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && articleGroup.isPromo) {
			return 0;
		}
		if (articleGroup) {
			const findGroup = articleGroup.article.groups.find(it => it._id === articleOption.group);
			if (findGroup) {
				if (findGroup.tags.find(it => it.identifier === 'half_pizza')) {
					return 0;
				}
			}
		}
		return price * articleOption.quantity;
	}
	createOrderForm() {
		const formControlNames: any = {};

		formControlNames[this.name] = ['', [Validators.required, Validators.pattern(/\w+\s\w+/)]];

		formControlNames[this.email] = [
			'',
			[
				Validators.required,
				Validators.pattern(
					"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
				),
			],
		];

		formControlNames[this.phone] = [
			'',
			[Validators.required, this._customPhoneValidatorForLibrary, this._customPhoneValidatorForGermany],
		];

		formControlNames[this.note] = ['', []];

		formControlNames[this.orderAt] = [''];
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			formControlNames[this.street] = ['', [Validators.required]];
			formControlNames[this.city] = ['', [Validators.required]];
			formControlNames[this.postalCode] = ['', [Validators.required]];
			formControlNames[this.number] = ['', [Validators.required]];
		}
		this.orderForm = this.fb.group(formControlNames);
		this.checkCustomer();
		this.reloadAddress();
	}

	_customPhoneValidatorForGermany(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}

		const phoneNumber = control.value.country + control.value.phone.toString();

		if (phoneNumber.startsWith('00')) {
			return { invalidPhone: 'Invalid format: use "+" instead of "00"' };
		}

		if (phoneNumber.startsWith('+490') || phoneNumber.startsWith('+430')) {
			return { invalidPhone: 'Phone number should not start with +490' };
		}
		const digitOnlyRegex = /^\+49\d+$/;
		const digitOnlyRegex2 = /^\+43\d+$/;
		if (phoneNumber.startsWith('+49')) {
			if (!digitOnlyRegex.test(phoneNumber)) {
				return { invalidPhone: 'Phone number must contain digits only.' };
			}
		}
		if (phoneNumber.startsWith('+43')) {
			if (!digitOnlyRegex2.test(phoneNumber)) {
				return { invalidPhone: 'Phone number must contain digits only.' };
			}
		}
		if (phoneNumber.length > 15) {
			return { invalidPhone: 'Phone number cannot exceed 15 digits.' };
		}

		if (phoneNumber.length < 12) {
			return { invalidPhone: 'Phone number must have at least 9 digits after +49.' };
		}

		return null;
	}
	private _e164PhoneNumberValidator(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		const phoneNumberRegex = /^\+[1-9]\d{1,14}$/;
		const phoneNumber = control?.value?.country + control?.value?.phone.toString();
		// return (control: AbstractControl): ValidationErrors | null => {
		//   if (!control.value) return null; // Don't validate empty values

		const valid = phoneNumberRegex.test(phoneNumber);
		return valid ? null : { invalidPhone: true };
		// };
	}
	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value?.country + control?.value?.phone.toString());
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	getFormControlValue(controlName?: string) {
		if (controlName) {
			return this.orderForm.get(controlName)?.value;
		}
		return '';
	}
	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.hasError('required') && this.orderForm?.get(controlName)?.touched;
		}
		return this.orderForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm?.get(controlName)?.errors && !this.orderForm?.get(controlName)?.hasError('required');
		}
		return this.orderForm.invalid;
	}

	getErrorsForm(controlName) {
		if (controlName) {
			return this.orderForm.get(controlName).errors;
		}

		return null;
	}

	private _customPhoneValidator(control: AbstractControl) {
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value);
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	handleChangeRadio(event: { detail: { value: string } }) {
		console.log(event.detail.value);
	}
	totalPrice() {
		console.log('BEFORE MAP', this.order, this.venue);
		this.totalPriceValue = numberToCurrency(
			OrderUtils.orderTotalPrice(this.order, true, true, this.repository.companyCode$.getValue() ?? null) + this.tip,
			this.order.currency
		);
		this.totlaPriceBeforeDiscount = numberToCurrency(
			OrderUtils.orderTotalPrice(this.order, false, false) + this.tip,
			this.order.currency
		);
		if (!this.companyDisount) {
			const code = this.repository.companyCode$.getValue();
			console.log(code);
			if (code && code.storeDiscount) {
				this.companyDisount = (Number(code.storeDiscount) * 100).toString() + '%';
			}
		}
		// if (this.venue) {
		// 	const foundArticleIndex = this.order.orderedArticles.findIndex(it => it.isHalfPizza);
		// 	if (foundArticleIndex >= 0) {
		// 		console.log('here before calc');
		// 		const foundArticle = this.venue.articleCategories
		// 			.map(it => it.articles.find(ar => ar.tags.find(tag => tag.identifier == 'appliesMostExpensive')))
		// 			.filter(it => !!it);
		// 		console.log(foundArticle);
		// 		if (foundArticle.length > 0) {
		// 			let mappedOrder = JSON.parse(JSON.stringify(this.order));
		// 			mappedOrder.orderedArticles = mappedOrder.orderedArticles.map(it => {
		// 				if (it.isHalfPizza) {
		// 					it.article = foundArticle[0];
		// 				}
		// 				return it;
		// 			});
		// 			// mappedOrder.orderedArticles[foundArticleIndex].article = foundArticle[0];
		// 			this.totalPriceValue = numberToCurrency(
		// 				OrderUtils.orderTotalPrice(mappedOrder, true, true) + this.tip,
		// 				this.order.currency
		// 			);
		// 			return;
		// 		}
		// 	}
		// } else {
		// 	this.totalPriceValue = numberToCurrency(OrderUtils.orderTotalPrice(this.order, true, true) + this.tip, this.order.currency);
		// }
	}
	changeTip(tip: number) {
		this.tip = tip;
		this.totalPrice();
	}

	checkPriceArticle(articleGroup: ArticleGroup, orderType: OrderType, preorderType: PreorderType) {}
	mapGroup(articleGroup: ArticleGroup) {
		if (!this.venue || !this.order) {
			return articleGroup;
		}
		if (this.venue) {
			const foundArticle = this.venue.articleCategories
				.map(it => {
					if (it.visible) {
						const foundArticle = it.articles.find(ar => ar._id === articleGroup.article._id);

						return foundArticle ?? null;
					} else {
						return null;
					}
				})
				.filter(it => !!it);
			if (foundArticle.length === 1) {
				const test = JSON.parse(JSON.stringify(articleGroup)) as ArticleGroup;
				test.article = JSON.parse(JSON.stringify(foundArticle[0]));

				return test;
			}
			return articleGroup;
		}
		return articleGroup;
	}
	async checkSlotQuate(time: Moment, error = false) {
		try {
			const result = await this.validateOfSpecifirSlotsForDeliveryWithUber(time.toString(), error);
			return { value: time, result };
		} catch (e) {
			return { value: time, result: null };
		}
	}
	async validateOfSpecifirSlotsForDeliveryWithUber(time: string, isHaveError: Boolean = false) {
		const venueAdress = {
			street: this.venue.street,
			number: this.venue.number,
			postalCode: this.venue.postalCode,
			city: this.venue.city.de,
			country: this.venue.country,
			lng: this.venue.location.coordinates[0],
			lat: this.venue.location.coordinates[1],
			state: this.venue.state,
		};
		const params = {
			pickup_address: MapsUtils.addressToString(venueAdress),
			dropoff_address: MapsUtils.addressToString(this.address),
			pickup_latitude: this.venue.location.coordinates[1],
			pickup_longitude: this.venue.location.coordinates[0],
			dropoff_latitude: this.address.lat,
			dropoff_longitude: this.address.lng,
			pickup_ready_dt: new Date(new Date(time).getTime() - (this.venue.offsets.preorder.delivery.first + 10) * 60000).toISOString(),
			pickup_deadline_dt: new Date(time).toISOString(),
			dropoff_ready_dt: new Date(time).toISOString(),
			dropoff_deadline_dt: new Date(new Date(time).getTime() + 20 * 60000).toISOString(),
			pickup_phone_number: this.venue.phoneNumber,
			dropoff_phone_number: this.getFormControlValue('phone')?.internationalNumber,
			manifest_total_value: Math.round(this.orderUtils.orderTotalPrice(this.order, true, true) + this.tip),
			external_store_id: '',
		};

		try {
			if (isHaveError && !this.venue.uberDeliveryEnabled) {
				return null;
			}
			return await Api.checkQoate(params, this.venue.uberCustomerId);
		} catch (e) {
			if (!isHaveError) {
				this.snackbarCtrl.open('Driver is not available at this time slot, try another one...', null, {
					duration: 4000,
				});
			}

			return null;
		}
	}
	async selectTimeSlot(time: string) {
		try {
			this.loadQoate = true;

			const result = await this.validateOfSpecifirSlotsForDeliveryWithUber(time);
			this.loadQoate = false;
			if (result) {
				this.uberQoateExist = true;
				await AvailableDriverModalComponent.show(this.modalCtrl);
				return;
			}
			this.slots = this.slots.filter(it => !it.isSame(time));
			this.snackbarCtrl.open('Sorry on this time drivers is not avaible....', null, {
				duration: 4000,
			});
		} catch (e: any) {
			this.loadQoate = false;
		}
	}

	isFormValid() {
		if (this.order.preorder.type === PreorderType.DELIVERY && this.venue?.uberDeliveryEnabled) {
			return this.orderForm?.valid && this.uberQoateExist && this.orderForm?.get('phone')?.value?.phone;
		}
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			return this.orderForm?.valid && this.orderForm?.get('phone')?.value?.phone;
		}
		return this.orderForm?.valid && this.orderForm?.get('phone')?.value?.phone;
	}
}
